import themable from '_uikit/_themable'

export const Default = themable('EventDefaultTile')

export default { Default }
